var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-lg-6 d-flex flex-column justify-content-between mt-2 px-lg-3 p-0"
  }, [_c('div', [_c('rating-stars', {
    attrs: {
      "rating": _vm.stars,
      "size": "16",
      "theme": "orange"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "review-info mt-1 mb-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.user))]), _vm._v(" "), _vm.experience ? _c('p', [_vm._v("\n        " + _vm._s(_vm.experience) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator my-3"
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };